export const strings = {
    'Carousel_Next': "Next",
    'Carousel_Previous': "Previous",
    'Carousel_Slide': "Slide {0}",
    'Carousel_SlideIndicators': "Choose slide to display",
    'ChainOfThought_Complete': "Complete",
    'DataGrid_NoRowsSelected': "No rows selected",
    'DataGrid_ResizeColumn': "Resize {column} column",
    'DataGrid_ResizeColumnValueText': "{width} pixels",
    'DataGrid_ResizeModeEntered': "Resizing {column} column. Use arrow keys.",
    'DataGrid_RowsSelected': "{count} of {total} rows selected",
    'DataGrid_SelectAllRows': "Select all rows",
    'DataGrid_SelectRow': "Select row",
    'DataGrid_SortAscending': "Sort ascending",
    'DataGrid_SortDescending': "Sort descending",
    'DataGrid_SortedByAscending': "Sorted by {column} ascending",
    'DataGrid_SortedByDescending': "Sorted by {column} descending",
    'DynamicTab_CloseHint': "Use close button or context menu to remove tab",
    'DynamicTab_CloseTab': "Close tab",
    'DynamicTab_Modified': "Modified",
    'DynamicTabList_CloseAll': "Close all tabs",
    'DynamicTabList_CloseUnmodified': "Close unmodified tabs",
    'DynamicTabList_ManageTabs': "Manage tabs",
    'Modal_Back': "Back",
    'Modal_Close': "Close",
    'Modal_Dismiss': "Dismiss",
    'Modal_Done': "Done",
    'Modal_Next': "Next",
    'Modal_PrimaryAction': "OK",
    'Modal_TryLater': "Try Later",
    'Pagination_FirstPage': "First page",
    'Pagination_LastPage': "Last page",
    'Pagination_Navigation': "Pagination",
    'Pagination_Next': "Next",
    'Pagination_NextPage': "Next page",
    'Pagination_PageButton': "Page {page}",
    'Pagination_PageNumbers': "Page numbers",
    'Pagination_PageOption': "Page {page} of {total}",
    'Pagination_PageSummary': "Page summary",
    'Pagination_Previous': "Previous",
    'Pagination_PreviousPage': "Previous page",
    'RangeSlider_InputLabelEnd': "Maximum value",
    'RangeSlider_InputLabelStart': "Minimum value",
    'RangeSlider_MaxThumbLabel': "Maximum",
    'RangeSlider_MinThumbLabel': "Minimum",
    'SearchBox_Clear': "clear",
    'Slider_InputLabel': "Value",
    'VariablePickerField_ConnectionName': "Connection name",
    'VariablePickerField_ConnectionType': "Connection type",
    'VariablePickerField_ItemName': "Item name",
    'VariablePickerField_ItemType': "Item type",
    'VariablePickerField_LearnMore': "Learn more",
    'VariablePickerField_Loading': "Loading",
    'VariablePickerField_PickVariable': "Pick a variable",
    'VariablePickerField_ResolveError_ActiveValueSetNotFound_Description': "The active value set configured for this variable library does not exist. Update the active value set and try again.",
    'VariablePickerField_ResolveError_ActiveValueSetNotFound_Title': "Active value set not found",
    'VariablePickerField_ResolveError_Generic_Description': "We couldn't resolve this variable reference. Try again.",
    'VariablePickerField_ResolveError_Generic_Title': "Couldn't resolve reference",
    'VariablePickerField_ResolveError_InvalidReferenceFormat_Description': "This variable reference isn't formatted correctly. Fix the reference and try again.",
    'VariablePickerField_ResolveError_InvalidReferenceFormat_Title': "Reference format is invalid",
    'VariablePickerField_ResolveError_InvalidReferenceInlineTypeNotAllowed_Description': "This variable reference doesn't support inline type specification. Remove the type specification and try again.",
    'VariablePickerField_ResolveError_InvalidReferenceInlineTypeNotAllowed_Title': "Type specification is not allowed",
    'VariablePickerField_ResolveError_InvalidVariableDefinition_Description': "One or more variable definitions in this variable library are invalid. Fix the variable definitions and try again.",
    'VariablePickerField_ResolveError_InvalidVariableDefinition_Title': "Variable definition is invalid",
    'VariablePickerField_ResolveError_InvalidVariableOverride_Description': "One or more variable overrides are invalid. Fix the override values and try again.",
    'VariablePickerField_ResolveError_InvalidVariableOverride_Title': "Variable override is invalid",
    'VariablePickerField_ResolveError_ReferencedEntityAccessDenied_Description': "You do not have read permission for the referenced item. Request access and try again.",
    'VariablePickerField_ResolveError_ReferencedEntityAccessDenied_Title': "Access to referenced item denied",
    'VariablePickerField_ResolveError_ReferencedEntityNotFound_Description': "The referenced item was not found. Check that the item still exists and try again.",
    'VariablePickerField_ResolveError_ReferencedEntityNotFound_Title': "Referenced item not found",
    'VariablePickerField_ResolveError_ReferencedEntityNotFoundOrAccessDenied_Description': "The referenced connection was not found, or you do not have permission to read it. Check the connection and your access, then try again.",
    'VariablePickerField_ResolveError_ReferencedEntityNotFoundOrAccessDenied_Title': "Referenced connection not found or access denied",
    'VariablePickerField_ResolveError_TypeMismatch_Description': "The referenced variable value type does not match the requested type. Update the requested type or the variable value and try again.",
    'VariablePickerField_ResolveError_TypeMismatch_Title': "Variable type mismatch",
    'VariablePickerField_ResolveError_UnexpectedError_Description': "We couldn't resolve the referenced item. Try again.",
    'VariablePickerField_ResolveError_UnexpectedError_Title': "Something went wrong",
    'VariablePickerField_ResolveError_VariableLibraryCorrupted_Description': "This variable library is corrupted, so the system can't resolve it right now. Contact support if the issue continues.",
    'VariablePickerField_ResolveError_VariableLibraryCorrupted_Title': "Variable library is corrupted",
    'VariablePickerField_ResolveError_VariableLibraryNotFound_Description': "The variable library was not found, or you do not have permission to read it. Check the reference and your access, then try again.",
    'VariablePickerField_ResolveError_VariableLibraryNotFound_Title': "Variable library not found",
    'VariablePickerField_ResolveError_VariableLibraryReferenceIsAmbiguous_Description': "We found multiple variable library items that match this reference. Use a more specific reference and try again.",
    'VariablePickerField_ResolveError_VariableLibraryReferenceIsAmbiguous_Title': "Variable library reference is ambiguous",
    'VariablePickerField_ResolveError_VariableLibraryReferenceIsMissing_Description': "This reference is missing its variable library. Provide a complete reference and try again.",
    'VariablePickerField_ResolveError_VariableLibraryReferenceIsMissing_Title': "Variable library reference is missing",
    'VariablePickerField_ResolveError_VariableNotFound_Description': "The referenced variable was not found in this variable library. Verify the variable name and try again.",
    'VariablePickerField_ResolveError_VariableNotFound_Title': "Variable not found",
    'VariablePickerField_Type': "Type",
    'VariablePickerField_Value': "Value",
    'VariablePickerField_VariableInfo': "Variable info",
    'VariablePickerField_ViewVariables': "View variables",
    'VariablePickerField_WorkspaceName': "Workspace name",
};
